// extracted by mini-css-extract-plugin
module.exports = {"chooseBox":"ChartOptions_chooseBox__1vrUy"};